function escapeHtml (value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * HTML do modal "remover do catálogo" (SweetAlert2).
 */
export function buildOrcCatalogRemoveSwalHtml ({ serviceName, labels }) {
  return `
    <div class="orc-swal">
      <div class="orc-swal__icon orc-swal__icon--warning" aria-hidden="true">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.75">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
        </svg>
      </div>
      <h2 class="orc-swal__title">${escapeHtml(labels.title)}</h2>
      <p class="orc-swal__subtitle">${escapeHtml(labels.subtitle)}</p>
      <div class="orc-swal__card">
        <span class="orc-swal__label">${escapeHtml(labels.serviceLabel)}</span>
        <span class="orc-swal__value">${escapeHtml(serviceName)}</span>
      </div>
      <p class="orc-swal__hint">
        <svg class="orc-swal__hint-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span>${escapeHtml(labels.hint)}</span>
      </p>
    </div>
  `
}

export const ORC_CATALOG_REMOVE_SWAL_CLASS = {
  popup: 'orc-swal-popup orc-swal-popup--catalog-remove',
  htmlContainer: 'orc-swal-html',
  actions: 'orc-swal-actions',
  confirmButton: 'orc-swal-btn orc-swal-btn--danger',
  cancelButton: 'orc-swal-btn orc-swal-btn--cancel',
  closeButton: 'orc-swal-close'
}
